if (!customElements.get('starside-product-video')) {
  customElements.define('starside-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const button = this.querySelector('button');
      const id = this.dataset.videoId;
      if (!button || !/^[A-Za-z0-9_-]{11}$/.test(id || '')) return;
      this.ready = true;
      // The existing Amazon layout moves the buying card into a display:contents
      // wrapper after load. Keep one video block and place it after that card on
      // mobile, or inside the gallery column on desktop, without cloning media.
      const product = this.closest('product-info');
      const block = this.closest('.starside-product-video');
      if (product && block) {
        const mobile = window.matchMedia('(max-width: 749px)');
        const place = () => {
          if (!product.classList.contains('product-amazon--ready')) return;
          const gallery = product.querySelector('.product__media-wrapper');
          const buy = product.querySelector('.product-amazon__buy-card');
          if (mobile.matches && buy && block.previousElementSibling !== buy) buy.after(block);
          else if (!mobile.matches && gallery && block.parentElement !== gallery) gallery.append(block);
        };
        mobile.addEventListener('change', place);
        new MutationObserver(place).observe(product, {attributes:true,attributeFilter:['class']});
        place();
      }
      button.addEventListener('click', () => {
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        frame.title = this.dataset.videoTitle;
        frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        this.replaceChildren(frame);
        frame.focus();
      }, {once:true});
    }
  });
}
